import {
    CREATE_CUSTOMER,
    DOWNLOAD_CUSTOMER_CSV,
    DOWNLOAD_CUSTOMER_CSV_FAILURE,
    DOWNLOAD_CUSTOMER_CSV_SUCCESS,
    GET_CUSTOMERS,
    GET_CUSTOMER_DETAILS,
    GET_CUSTOMER_TRANSACTION,
    GET_CUSTOMER_TRANSACTION_FAILURE,
    GET_CUSTOMER_TRANSACTION_SUCCESS,
    SET_CUSTOMERS,
    SET_CUSTOMER_DETAILS,
    UPDATE_CUSTOMER_DETAILS
} from './actionTypes';

export const getCustomers = data => {
    return {
        payload: data,
        type: GET_CUSTOMERS
    };
};
export const setCustomers = data => {
    return {
        payload: data,
        type: SET_CUSTOMERS
    };
};
export const createCustomer = data => {
    return {
        payload: data,
        type: CREATE_CUSTOMER
    };
};
export const getCustomerDetials = data => {
    return {
        payload: data,
        type: GET_CUSTOMER_DETAILS
    };
};
export const setCustomerDetials = data => {
    return {
        payload: data,
        type: SET_CUSTOMER_DETAILS
    };
};
export const updateCustomerDetails = data => {
    return {
        payload: data,
        type: UPDATE_CUSTOMER_DETAILS
    };
};

export const downloadCustomerCsv = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_CUSTOMER_CSV
    }
}

export const downloadCustomerCsvFailure = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_CUSTOMER_CSV_FAILURE
    }
}

export const downloadCustomerCsvSuccess = (data) => {
    return {
        payload: data,
        type: DOWNLOAD_CUSTOMER_CSV_SUCCESS
    }
}

export const getCustomerTransaction = (data) => {
    return {
        payload: data,
        type: GET_CUSTOMER_TRANSACTION
    }
}

export const setCustomerTransaction = (data) => {
    return {
        payload: data,
        type: GET_CUSTOMER_TRANSACTION_SUCCESS
    }
}

export const getCustomerTransactionFailure = (data) => {
    return {
        payload: data,
        type: GET_CUSTOMER_TRANSACTION_FAILURE
    }
}
